/**
 * Pre-qualification decision outcome.
 * Distinct from PreQualificationStatus on LeadData — this is the raw credit decision,
 * while PreQualificationStatus is the lead-level interpretation.
 */
const PreQualDecision = {
    APPROVED: 'APPROVED',
    DENIED: 'DENIED',
    /** Freedom Road prequalified the buyer. */
    PREQUALIFIED: 'PREQUALIFIED',
    /** Freedom Road referred the buyer to the dealer; never a rejection. */
    REFERRED: 'REFERRED',
    /** Freedom Road had not decided when Ekho stopped waiting. */
    PENDING: 'PENDING',
};
/** Whether a decision prequalified the buyer, on any decision path. */
function isPrequalifiedDecision(decision) {
    return decision === PreQualDecision.APPROVED || decision === PreQualDecision.PREQUALIFIED;
}
/**
 * Which policy produced a decision. `lender_buy_box` judges the buyer against
 * the rooftop's configured lenders; `svp_fico_floor` is a single-threshold
 * comparison against the program owner's own minimum score; `finio` is Freedom
 * Road's decision, made through Finio. Reporting-only: it names the code path,
 * never a score or a threshold.
 */
const PreQualDecisionBasis = {
    LENDER_BUY_BOX: 'lender_buy_box',
    SVP_FICO_FLOOR: 'svp_fico_floor',
    FINIO: 'finio',
};

export { PreQualDecision, PreQualDecisionBasis, isPrequalifiedDecision };
//# sourceMappingURL=PreQualSubmission.js.map
